<svg width="0" height="0" class="cg3-icon-sprite">
    <symbol id="wk-icon-client-code" viewBox="0 0 16 16">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12,4.3v-.2s.4-3,.4-3h-1.2l-.4,3.1h0c0,.1-.1.1-.1.1h-4.7v-.2s.4-3,.4-3h-1.2l-.4,3.1h0c0,.1-.1.1-.1.1H1.2v1.2h3.5v.2s-.5,4.5-.5,4.5h0c0,.1-.1.1-.1.1H1.2v1.2h2.8v.2s-.4,3-.4,3h1.2l.4-3.1h0c0-.1.1-.1.1-.1h4.7v.2s-.4,3-.4,3h1.2l.4-3.1h0c0-.1.1-.1.1-.1h3.5v-1.2h-3.5v-.2s.5-4.5.5-4.5h0c0-.1.1-.1.1-.1h2.8v-1.2h-2.8ZM10.6,5.7l-.5,4.5h0c0,.1-.1.1-.1.1h-4.7v-.2s.5-4.5.5-4.5h0c0-.1.1-.1.1-.1h4.7v.2Z"
        />
    </symbol>
</svg>
